import { TActions } from '../../../AppModulesWrapper';

import {
  CHANGE_ACTIVE_SERVICE_ID,
  CHANGE_IS_SERVICES_ENABLED,
  CHANGE_PLACING_TYPE,
  CHANGE_PROMOTION_SERVICE,
  CHANGE_SELECTED_PACKAGE_ID,
  LOAD_PUBLISH_TERMS_FAIL,
  LOAD_PUBLISH_TERMS_START,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PACKAGE,
  SELECT_PLACING_PERIOD,
  SELECT_PLACING_TYPE,
  SELECT_PUBLISH_TERMS_SERVICE,
  SET_IS_SERVICES_ENABLED,
  SET_PLACING_MONEY_SOURCE,
  SET_PROMOTION_TYPE_CHANGE_REASON,
} from '../../actions/publishTerms';
import { RESET_STATE } from '../../actions/resetState';
import { EPublishTermsStatus, IPublishTermsState } from '../../types/reducers/publishTerms';
import { publishTermsDefaultState } from './defaultState';
import { mergePublishTerms, syncPeriodId } from './utils';

export function publishTerms(
  state: IPublishTermsState = publishTermsDefaultState,
  action: TActions,
): IPublishTermsState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_START: {
      const nextState = { ...state, error: null };

      if (action.payload.isReloading) {
        nextState.isServicesReloading = true;
      } else {
        nextState.status = EPublishTermsStatus.pending;
      }

      return nextState;
    }

    case LOAD_PUBLISH_TERMS_SUCCESS: {
      // сохраняем предыдущее состояние
      const publishTerms = mergePublishTerms({
        prevTerms: state,
        nextTerms: action.payload.publishTerms,
      });

      return {
        ...state,
        ...publishTerms,
        status: EPublishTermsStatus.success,
        isServicesReloading: false,
        moneySource: action.payload.publishTerms.moneySource,
      };
    }

    case LOAD_PUBLISH_TERMS_FAIL: {
      return {
        ...state,
        status: EPublishTermsStatus.fail,
        isServicesReloading: false,
        error: action.payload || null,
      };
    }

    case SELECT_PUBLISH_TERMS_SERVICE: {
      const { selectedPeriodId, periodsByService } = state;
      const periodsInfo = periodsByService[action.payload];
      const syncedPeriodId = periodsInfo ? syncPeriodId({ selectedPeriodId, ...periodsInfo }) : null;

      return {
        ...state,
        selectedPeriodId: syncedPeriodId,
        selectedServiceId: action.payload,
      };
    }

    case SELECT_PLACING_TYPE: {
      return {
        ...state,
        selectedPlacingType: action.payload,
        isPlacingTypeChangedByUser: true,
      };
    }

    case CHANGE_PLACING_TYPE: {
      return {
        ...state,
        selectedPlacingType: action.payload,
        isPlacingTypeChangedByUser: false,
      };
    }

    case CHANGE_SELECTED_PACKAGE_ID:
    case SELECT_PACKAGE: {
      return {
        ...state,
        selectedPackageId: action.payload,
      };
    }

    case SELECT_PLACING_PERIOD: {
      return {
        ...state,
        selectedPeriodId: action.payload,
      };
    }

    case CHANGE_PROMOTION_SERVICE: {
      return {
        ...state,
        promotionServiceId: action.payload,
      };
    }

    case SET_PLACING_MONEY_SOURCE: {
      return {
        ...state,
        moneySource: action.payload,
      };
    }

    case CHANGE_IS_SERVICES_ENABLED:
    case SET_IS_SERVICES_ENABLED: {
      return {
        ...state,
        isServicesEnabled: action.payload,
      };
    }

    case SET_PROMOTION_TYPE_CHANGE_REASON: {
      return {
        ...state,
        promotionTypeChangeReason: action.payload,
      };
    }

    case CHANGE_ACTIVE_SERVICE_ID: {
      return {
        ...state,
        selectedServiceId: action.payload,
      };
    }

    case RESET_STATE:
      return {
        ...publishTermsDefaultState,
      };

    default:
      return state;
  }
}
